/** The standard origin in an installation snippet is not a custom endpoint. */
export function allowsConfiguredEdge(explicitApiUrl?: string): boolean {
  return !explicitApiUrl || explicitApiUrl.replace(/\/+$/, '') === 'https://consentpop.com';
}
